import { Link } from "react-router-dom";

export function Logo({ size = "h-14", className = "" }) {
  return (
    <Link to="/" className={`inline-flex items-center ${className}`} data-testid="logo-home-link" aria-label="Losta Group accueil">
      <img
        src="/losta-logo.png"
        alt="Losta Group Holding"
        className={`${size} w-auto object-contain transition-transform duration-500 hover:scale-[1.03]`}
      />
    </Link>
  );
}
